module.exports = __webpack_public_path__ + "img/16.43b2cca8.jpg";